import { render, staticRenderFns } from "./mudar-senha-login.vue?vue&type=template&id=566e8344&"
import script from "./mudar-senha-login.vue?vue&type=script&lang=js&"
export * from "./mudar-senha-login.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports